import React, { ChangeEvent, useState } from 'react'
import Header from '../../components/common/Header'
import Upload from '../../components/System/Upload'
import { useUploadApi } from '../../hooks/useSampleApi'
import { useNavigate } from 'react-router-dom'
import { Container } from '../../components/common/System'

const UploadPage = () => {
  const navigate = useNavigate()
  const [excel, setExcel] = useState<File>()
  const [opt, setOpt] = useState('')

  const handleOptionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setOpt(e.target.value)
  }
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    console.log(e.currentTarget.files)
    if (e.currentTarget.files) {
      setExcel(e.currentTarget.files[0]) // only single file should be accepted
    }
  }

  // option에 맞춰서 여기 업로드해야 함
  const { mutate, isSuccess } = useUploadApi()

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData();
    formData.append("file", excel!)
    formData.append("opt", opt)

    console.log(formData)
    mutate(formData)
  }

  if (isSuccess) {
    if (opt === '학문프로파일') {
      navigate('/admin/system/view/profile')
    } else if (opt === '학과분류체계') {
      navigate('/admin/system/view/codebook')
    } else if (opt === '진단문항') {
      navigate('/admin/system/view/quiz')
    }
  }

  // thema와 맞춰서 css 업데이트 필요함
  return (
    <>
      <Header />
      <Container>
        <Upload
          opt = {opt}
          handleOptionChange={handleOptionChange}
          handleFileChange={handleFileChange}
          submitHandler={submitHandler}
        />
      </Container>
    </>
  )
}

export default UploadPage